module.exports = __webpack_public_path__ + "img/1.a46cca18.jpg";